import { isMobile } from '../../app-components/UtilityFunctions';
import vars from '../../theme/vars';

const loginStyle = {
  leftSide: {
    display: 'flex',
    width: '35%',
    flexDirection: 'column',
    backgroundColor: '#010101',
    color: 'white',
    padding: '4% 6%',
    justifyContent: 'space-around',
  },

  scrollViewStyle: {
    flex: 1,
    justifyContent: 'center',
    padding: isMobile && 20,
    alignItems: !isMobile && 'center',
    backgroundColor: 'rgba(196, 196, 196, 0.01)',
    backgroundImage: 'linear-gradient(to top, #fff, #fff8ee)',
  },

  loginBoxStyle: {
    flex: 1,
    overflow: 'hidden',
    borderColor: vars.colors.white,
  },

  loginText: {
    // marginBottom: !isMobile ? -25 : -17,
    zIndex: 1,
    fontFamily: 'Montessart',
    // fontSize: !isMobile ? 44 : 30,
    color: '#010101',
    fontWeight: 700,
    fontSize: 20,
    marginBottom: 0,
  },

  errorStyle: {
    ...vars.headings.h14,
    color: vars.colors.error,
    textAlign: 'center',
  },
};

export default loginStyle;
